// opervex-frontend/src/Opervex/Dashboard/index.js

import _PowerBI from "./PowerBI";

class Dashboard {
  #_api;

  constructor(api) {
    this.#_api = api;

    this.PowerBI = new _PowerBI(this.#_api);
  }
}

export default Dashboard;
